export const leadCohort = "C14";
